import { useCallback } from 'react';
import useCrud from 'hooks/useCrud';
import { fetchShopList, PlatformRegionParams } from 'services/api/oms';

function useShopList() {
  const readList = useCallback(
    (params: { scenarioType: Marketing.AllScenarioType } & PlatformRegionParams) => {
      const { scenarioType, ...others } = params;

      return fetchShopList(scenarioType, others).then((res) => res.shops);
    },
    [],
  );

  return useCrud({
    readList,
  });
}

export default useShopList;
